import '../styles/FinalPage.css'
import {useEffect} from "react";
import {RUTAS} from "constants/app";
import {useNavigate} from "react-router-dom";
import {useTheme} from "../providers/ThemeProvider";

export default function FinalPage() {
    const { theme } = useTheme();

    useEffect(() => {
        const token = localStorage.getItem("user-token");
        if (!token) return;

        const mapStr = localStorage.getItem("NOM035_tokenMap");
        const map = mapStr ? JSON.parse(mapStr) : {};
        const current = map[token] || {};

        // Validar campos mínimos del formulario
        const datos = current.demographics || {};

        const normaliza = (v?: string) => (v ?? "").trim().toLowerCase();
        const normalizaRango = (v?: string) =>
            normaliza(v).replace(/[\u2012-\u2015]/g, "-").replace(/\s+/g, " ");

        const sexoValido = ["masculino", "femenino"].includes(normaliza(datos.gender));
        const RANGOS_VALIDOS = [
            "15 – 19", "20 – 24", "25 – 29", "30 – 34", "35 – 39",
            "40 – 44", "45 - 49", "50 - 54", "55 - 59",
            "60 - 64", "65 - 69", "70 o más"
        ];

        const edadValida = RANGOS_VALIDOS
            .map(normalizaRango)
            .includes(normalizaRango(datos.ageRange));
        const hasDatosTrabajador = sexoValido && edadValida;

        // Validar respuestas de guías requeridas
        const guiasEsperadas = (Object.keys(current.answers ?? {}) as string[])
            .filter(Boolean);

        const hasAllAnswers = guiasEsperadas.every((g) => {
            const ans = current.answers?.[g];
            return ans && Object.keys(ans).length > 0;
        });

        const hasAllScores = guiasEsperadas.every((g) => {
            const sc = current.scores?.[g];
            return sc && Object.keys(sc).length > 0;
        });
        console.log("Todas las respuestas", hasAllAnswers);
        console.log("Todas los scores", hasAllScores);
        console.log("Todas los datos del trabajador", hasDatosTrabajador);
        if (hasDatosTrabajador && hasAllAnswers && hasAllScores) {
            map[token] = {
                ...current,
                finalizado: true,
            };

            localStorage.setItem("NOM035_tokenMap", JSON.stringify(map));
            localStorage.removeItem("user-token");
            localStorage.setItem("NOM035_tokenFinalizado", "true");
        } else {
            console.warn("No se puede marcar como finalizado: faltan datos válidos o respuestas completas.");
        }
    }, []);

    const navigate = useNavigate();

    function handleStart() {
        navigate(RUTAS.ROOT);
    }

    return (
        <div className="FinalPage">
            <div className="FinalPage-card">
                <div className="FinalPage-card-content">
                    <img src={theme?.assets.iconApprove} alt="Encuesta terminada" className="FinalPage-card-img"/>
                    <h1 className="title">{theme?.content.finalPage.title}</h1>
                    <div className="text">
                        {theme?.content.finalPage.message}
                    </div>

                    <button className="FinalPage-card-btn" onClick={handleStart}>
                        {theme?.content.finalPage.closeButton}
                    </button>
                </div>
            </div>
        </div>
    );
}